<template>
<div class="warp">
    <div id="container"></div>
    <Toolbar @selectMenu="selectMenu" @removefature="removefature" ref="toolbar"/>
    <TilesTransform :tileset="tileset" v-if="flagObj.isTransform"/>
    <TilesCutting :tileset="tileset" v-if="flagObj.isCutting"/>
    <Ranging v-if="flagObj.isRanging"/>
    <Textname v-show="isShow" @close="close" :textname="textname"/>
    <Feature :featureArr="featureArr" @close="close" @showHidden="showHidden" @remove="remove" v-show="isShowFature"/>
</div>
    
</template>

<script>
import * as Cesium from "cesium/Cesium";
import * as widgets from "cesium/Widgets/widgets.css";

window.viewer = null
window.Cesium = Cesium
window.earth = null
window.convenient = null
import InitCesium from './viewer/js/initCesium'
import Convenient from './viewer/js/convenient'
import Tiles from './viewer/js/model'
import { tilesUrl } from '../utils/config'
const Toolbar = ()=> import('./editor1/Toolbar.vue')
const TilesTransform = ()=> import('./editor/TilesTransform.vue')
const TilesCutting = ()=> import('./editor/TilesCutting.vue')
const Ranging = ()=> import('./editor/Ranging.vue')
const Textname = ()=> import('./editor/Textname.vue')
const Feature = ()=> import('./editor1/Feature.vue')

import json1 from '../../public/room/scenetree.json'
export default {
    components:{
        Toolbar, TilesTransform, TilesCutting, Ranging, Textname, Feature
    },
    data(){
        return {
            tileset:null,
            isShow:false,
            isShowFature:false,
            tile:new Tiles(),
            flagObj:{
                isTransform:false,
                isCutting:false,
                isRanging:false
            },
            json: require('../../public/room/scenetree.json'),
            json1,
            textname:'',
            feature:[], // 所有特征
            featureArr:[],  // 选中要隐藏的特征
            handler:null,
            select:{
                feature:undefined,
                color: new Cesium.Color()
            },
            floorView:{
                homeView:{
                    x: -2065615.9516957277,
                    y: 5622957.097074436,
                    z: 2182699.3329791985,
                    heading:0.9848181182936768,
                    pitch:-0.3967080483098131,
                    roll:6.283185029478362
                },
                FrontView:{ // 前
                    x: -2065603.6954677901,
                    y: 5622945.120959369,
                    z: 2182713.4166532317,
                    heading:1.6342906762118297,
                    pitch:-0.06961388514772504,
                    roll:6.283185289148797
                },
                RearView:{ // 后
                    x: -2065659.9019794676,
                    y: 5622923.568951603,
                    z: 2182711.8092028443,
                    heading:4.73126931623017,
                    pitch:-0.02944443438166533,
                    roll:6.283185233732774
                },
                LeftView:{ // 左
                    x: -2065630.0895887448,
                    y: 5622924.8538937215,
                    z: 2182736.4174445434,
                    heading:3.126718496051028,
                    pitch:-0.017967483848366994,
                    roll:4.1441571951850165e-8
                },
                RightView:{ // 右
                    x: -2065636.716327787,
                    y: 5622941.405579024,
                    z: 2182684.154645564,
                    heading:0.023373499296857503,
                    pitch:0.010724919314730519,
                    roll:6.283185241499344
                },
                TopView:{ // 上
                    x: -2065641.812035496,
                    y: 5622956.884916128,
                    z: 2182720.042062426,
                    heading:6.276497470584937,
                    pitch:-1.5386688234597128,
                    roll:0
                },
            },
            clippings:{},
            planeEntys:[], // 实体的切面
            targetY:0
            
        }
    },
    mounted(){
        this.init()
        this.addClipPlanes()
        
    },
    methods:{
        init(){
            Cesium.Ion.defaultAccessToken =
                'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIyYjZjYWUyZi00YWRkLTRjMjUtYmNmNC0xMWViMjgxYjI4MDgiLCJpZCI6NjYxMjEsImlhdCI6MTYzMDY1MzcxN30.GTEf3cn_2IGsuOoqIuznPJ_D8py8PUt97UG7THjymnc';
            earth = new InitCesium('container', {
                skyAtmosphere: false,
                shouldAnimate : true,
                terrainProvider: Cesium.createWorldTerrain()
            });

            viewer.imageryLayers.addImageryProvider(
                new Cesium.WebMapTileServiceImageryProvider({   
                    url: 'http://t0.tianditu.gov.cn/cia_w/wmts?tk=65f301fcf76d9c4af0682eee02b7a7b9',
                    layer:'cia',
                    style:'default',
                    tileMatrixSetID:'w',
                    format:'tiles',
                    maximumLevel: 18
                })
            );
            viewer.scene.globe.depthTestAgainstTerrain = true;
            convenient = new Convenient({viewer})
            
            this.addThreeTiles()

            // this.degrees()
            
        },
        addThreeTiles(){
            let _this = this
            let tile = this.tile.addThreeTiles({
                // url:'/gltf/tileset.json',
                url:tilesUrl +'/room/tileset.json',
                name : '3dTiles',
                positionModel : {
                    lon:110.17124729849168,
                    lat:20.144414070889173,
                    alt:-6
                },
                scaleNum :1
            })
            // viewer.zoomTo(tile.tiles)
            convenient.fly(this.floorView.homeView)
            this.tileset = tile.tiles
            this.feature = tile.tileFeature
            console.log(this.tileset);

            
            console.log(this.json);
            console.log(this.json1);

            // this.handler()
            
        },
        removefature(){
            this.removeClip()
            this.close()
        },
        selectMenu(menu){
            let _this = this
            console.log(menu);
            _this.resetFlag()
            switch(menu.bar){
                case '裁切':
                    _this.flagObj.isCutting = menu.falg
                    break;
                case '旋转':
                    _this.flagObj.isTransform = menu.falg
                    break;
                case '测距':
                    _this.flagObj.isRanging = menu.falg
                    break;
                case '主视图':
                    convenient.fly(_this.floorView.homeView)
                    break;
                case '前视角':
                    convenient.fly(_this.floorView.FrontView)
                    break;
                case '后视角':
                    convenient.fly(_this.floorView.RearView)
                    break;
                case '左视角':
                    convenient.fly(_this.floorView.LeftView)
                    break;
                case '右视角':
                    convenient.fly(_this.floorView.RightView)
                    break;
                case '顶视角':
                    convenient.fly(_this.floorView.TopView)
                    break;
                case '构件信息':
                    _this.isShow = true
                    _this.isShowFature = false
                    _this.inithandler()
                    break;
                case '构件隐藏': 
                    _this.isShowFature = true
                    _this.isShow = false
                    _this.inithandler()
                    break;
                case 'x轴裁切': 
                    _this.removeClip()
                    _this.initHndler()
                    _this.selectClip(_this.clippings.xPlane)
                    break;
                case 'y轴裁切': 
                    _this.removeClip()
                    _this.initHndler()
                    _this.selectClip(_this.clippings.yPlane)
                    break;
                case 'z轴裁切': 
                    _this.removeClip()
                    _this.initHndler()
                    _this.selectClip(_this.clippings.zPlane)
                    break;
            }
            
        },
        resetFlag(){
            for(let key in this.flagObj){
                this.flagObj[key] = false
            }
        },
        degrees(){
            let entityArr = []
            for(let i = -180;i<180;i++){
                for(let j = -90;j<90;j++){
                    entityArr.push(
                        viewer.entities.add({
                            polygon:{
                                hierarchy:Cesium.Cartesian3.fromDegreesArray([
                                    i, -j, 
                                    i , -j - 1,
                                    i + 1, - j - 1,
                                    i + 1, - j 
                                ]),
                                material:Cesium.Color.fromCssColorString('#00000001'),
                                height:0,
                                outline:true,
                                outlineWidth:1,
                                outlineColor:Cesium.Color.WHITE.withAlpha(0.1)
                            }
                        })
                    )
                }
            }
            let view = Cesium.Cartesian3.fromDegrees(-180, -90, 0)
            convenient.fly({
                x:view.x,
                y:view.y,
                z:view.z
            })
        },
        close(){
            if(this.handler){
                this.handler.destroy()
                this.handler = null
            }   
            
            this.isShow = false
            this.isShowFature = false
            this.$refs.toolbar.barIdx = 0
            this.feature.forEach(item =>{
                item.color = new Cesium.Color()
                item.show = true
            })
        },
        inithandler(){
            let _this = this
            _this.handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas)
            _this.handler.setInputAction((moment)=>{
                let pick = viewer.scene.pick(moment.position)
                console.log(pick);
                
                if(Cesium.defined(pick) ){
                    let propertyNames = pick.getPropertyNames()
                    // console.log(propertyNames);

                    let name = pick.getProperty(propertyNames.find(item =>item == 'name'))
                    console.log(name);
                    
                    let model = _this.feature.find(item => item.getProperty('name') == name)
                    
                    console.log(model);
                    if(_this.isShow){
                        if(Cesium.defined(_this.select)){
                            _this.select.color = new Cesium.Color()
                        }
                        if(_this.select == model){
                            _this.select = null
                            _this.textname = ''
                        }else{
                            _this.select = model
                            model.color = Cesium.Color.fromCssColorString('#ff5a00').withAlpha(1)
                            _this.textname = name
                        }

                        _this.feature.forEach(item =>{
                            if(item !== model){
                                item.color = Cesium.Color.WHITE.withAlpha(0.1)
                            }
                        })

                    }else if(_this.isShowFature){
                        let id = pick.getProperty(propertyNames.find(item =>item == 'id'))
                        let obj = {
                            id,
                            name,
                            show:false
                        }
                        _this.featureArr.push(obj)
                        model.show = false
                    }
                    
                }
                
                
            }, Cesium.ScreenSpaceEventType.LEFT_CLICK)
        },
        showHidden(model){
            console.log(model);
            let fature = this.feature.find(item => item.getProperty('name') == model.name)
            fature.show = model.show
        },
        remove(idx){
            let _this = this
            if(idx){
                let fature = _this.feature.find(item => item.getProperty('name') == this.featureArr[idx].name)
                fature.show = true
                this.featureArr.splice(idx, 1)
            }else {
                this.featureArr.forEach(model =>{
                    let fature = _this.feature.find(item => item.getProperty('name') == model.name)
                    fature.show = true
                })
                this.featureArr = []
            }
        },
        addClipPlanes(){
            let xPlane = {
                left : 0,
            }

            let yPlane = {
                before : 0,
            }

            let zPlane = {
                up : 0,
            }

            let rxPlane = {
                right : 0,
            }

            let ryPlane = {
                after : 0,
            }

            let rzPlane = {
                down : 0,
            }

            let boxPlaneOut = {
                left : -20,
                right: -20,
                before : -20,
                after : -20,
                up : -20,
                down:-20,
            }

            let boxPlaneIn = {
                left : 20,
                right: 20,
                before : 20,
                after : 20,
                up : 20,
                down:20,
                unionClippingRegions:true
            }

            this.clippings = {
                xPlane,
                yPlane,
                zPlane,
                rxPlane,
                ryPlane,
                rzPlane,
                boxPlaneIn,
                boxPlaneOut,
            }
        },
        selectClip(planes){
            let _this = this
            console.log(planes);
            this.tileset.clippingPlanes = convenient._clipPlanes(planes)
            let boundingSphere = _this.tileset.boundingSphere
            let arr = this.tileset.clippingPlanes
            for(let i = 0;i<arr.length;i++){
                let palne = arr._planes[i]
                console.log(palne);
                let planeEntity = viewer.entities.add({
                    name:'平面' + i,
                    position:boundingSphere.center,
                    plane:{
                        dimensions:new Cesium.Cartesian2(20, 20),
                        material:Cesium.Color.BLUE.withAlpha(0.1),
                        plane:new Cesium.CallbackProperty(createPlaneUpdateFunction(palne),false),
                        outline:true,
                        outlineColor:Cesium.Color.WHITE
                    }
                })
                _this.planeEntys.push(planeEntity)
            }

            function createPlaneUpdateFunction(plane) {
                return function () {
                    plane.distance = _this.targetY;
                    return plane;
                };
            }
        },
        initHndler(){
            let _this = this
            this.handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas)
            this.handler.setInputAction((moment)=>{
                let pick = viewer.scene.pick(moment.position)
                console.log(pick);
                if (
                    Cesium.defined(pick) &&
                    Cesium.defined(pick.id) &&
                    Cesium.defined(pick.id.plane)
                ) {
                    _this.selectedPlane = pick.id.plane;
                    _this.selectedPlane.material = Cesium.Color.WHITE.withAlpha(0.05);
                    _this.selectedPlane.outlineColor = Cesium.Color.ORANGE;
                    viewer.scene.screenSpaceCameraController.enableInputs = false;
                }
            }, Cesium.ScreenSpaceEventType.LEFT_DOWN)

            this.handler.setInputAction((moment)=>{
                if (Cesium.defined(_this.selectedPlane)) {
                    _this.selectedPlane.material = Cesium.Color.WHITE.withAlpha(0.1);
                    _this.selectedPlane.outlineColor = Cesium.Color.WHITE;
                    _this.selectedPlane = undefined;
                }

                viewer.scene.screenSpaceCameraController.enableInputs = true;
            }, Cesium.ScreenSpaceEventType.LEFT_UP)

            this.handler.setInputAction((moment)=>{
                if (Cesium.defined(_this.selectedPlane)) {
                    console.log(moment);
                    let deltaY = moment.startPosition.y - moment.endPosition.y;
                    this.targetY += deltaY *0.05;
                }
            }, Cesium.ScreenSpaceEventType.MOUSE_MOVE)

        },
        removeClip(){
            let noClippingPlanes = new Cesium.ClippingPlaneCollection({
                planes: [],
                edgeColor: Cesium.Color.WHITE,
                edgeWidth:1
            })
            this.tileset.clippingPlanes = noClippingPlanes
            this.planeEntys.forEach(item =>{
                viewer.entities.remove(item)
            })
            if(this.handler){
                this.handler.destroy()
                this.handler = null
            }
            this.targetY = 0
        },
    }
}
</script>

<style scoped lang="less">
.warp{
    position: relative;
}
#container{
    width: 100vw;
    height: 100vh;
    z-index: 0;
}
#win{
    position: absolute;
    top: 0;
    left: 1vw;
    width: 5vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    .btn{
        height: 3vh;
        line-height: 3vh;
        text-align: left;
        border: 1px solid gold;
    }
}
</style>